import { Control, Controller } from 'react-hook-form';
import { CreateProductFormSchemaType } from '../common';
import LOCALS from 'commons/locals';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import { Switch } from 'antd';

const ProductFacebookEnabled = ({
  control,
}: {
  control: Control<CreateProductFormSchemaType>;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel required>{i18n.t(LOCALS.facebookEnabled)}:</FormLabel>
      <Controller
        name="facebookEnabled"
        control={control}
        render={({ field }) => (
          <Switch
            {...field}
            checkedChildren={i18n.t(LOCALS.enable)}
            unCheckedChildren={i18n.t(LOCALS.disable)}
            value={field.value === 1}
            onChange={(value) => {
              field.onChange(value ? 1 : 0);
            }}
          />
        )}
      />
    </div>
  );
};

export default ProductFacebookEnabled;
